import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IType } from '../../../models/evaluation.model'
import { doGetTypes, doUpdateType } from '../../../store/convert.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/program/convert/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';
import SimpleHeader from '../../../components/layout/SimpleHeader';

interface IMatch {
  id: string;
}

const ProgramConvertEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.convert);
  
  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);

  const [type, setType] = useState<any>();

  useEffect(() => {
    getType();
  }, [])

  const getType = async () => {
    const res = await dispatch(doGetTypes());

    switch (res?.status) {
      case 200:
        {
          const type = res.data?.data?.find((item: IType) => item.typeCode === id);
          if (type) setType(type);
        }
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: IType) => {
    const res = await dispatch(doUpdateType(id, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/program/convert`);
        break;
      case 400:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), warningVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.convert.title3')}
      />
      <Editor
        type={type || null}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default ProgramConvertEdit;
